import { render, staticRenderFns } from "./go-upload.vue?vue&type=template&id=6c5c756b&scoped=true&"
import script from "./go-upload.vue?vue&type=script&lang=js&"
export * from "./go-upload.vue?vue&type=script&lang=js&"
import style0 from "./go-upload.vue?vue&type=style&index=0&id=6c5c756b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c756b",
  null
  
)

export default component.exports